// @internal
export function hasEntity(entities, id) {
    return entities.hasOwnProperty(id);
}
